import { useTranslation } from "react-i18next";

import { Icon } from "@atoms";
import { cn } from "@utils";

type BuildingOptionProps = {
  name: string;
  isSelected: boolean;
  isDefault: boolean;
  onChoose: () => void;
};

export const BuildingOption = ({ name, isSelected, isDefault, onChoose }: BuildingOptionProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-current={isSelected || undefined}
      className={cn(
        "flex w-full items-center gap-3 rounded-lg px-4 py-3 text-left text-mapiq-black-800* transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mapiq-black-800*",
        {
          "bg-beige-500* font-semibold": isSelected,
          "hover:bg-mapiq-black-50 focus-visible:bg-mapiq-black-50": !isSelected,
        },
      )}
      onClick={onChoose}>
      <Icon
        aria-hidden
        icon="office"
        color="currentColor"
        className="size-4 flex-none"
      />
      <span className="truncate">{name}</span>
      {isDefault && <span className="ml-auto flex-none text-sm text-mapiq-black-500">{t("translation:Default")}</span>}
    </button>
  );
};
